import type { ChatMessageView } from "web_myplann/Chat/Types/chatMessage";

export const createOptimisticChatMessage = (
	temporaryMessageId: number,
	content: string,
): ChatMessageView => ({
	id: temporaryMessageId,
	content,
	direction: "sender",
	isRead: false,
	createdAt: new Date(),
	fromName: "",
	attachments: [],
	pending: true,
});
